var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

const SvgCall = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 21C15.3463 20.9986 13.7183 20.5899 12.26 19.81L11.81 19.56C8.70075 17.8883 6.15169 15.3393 4.48 12.23L4.23 11.78C3.42982 10.3134 3.00713 8.67072 3 7.00003V6.33003C2.99958 5.79698 3.21196 5.28582 3.59 4.91003L5.28 3.22003C5.44413 3.05462 5.67581 2.9749 5.90696 3.00428C6.13811 3.03367 6.34248 3.16882 6.46 3.37003L8.71 7.23003C8.93753 7.62291 8.87183 8.11978 8.55 8.44003L6.66 10.33C6.50304 10.4853 6.46647 10.7251 6.57 10.92L6.92 11.58C8.17704 13.9085 10.0893 15.8172 12.42 17.07L13.08 17.43C13.275 17.5336 13.5148 17.497 13.67 17.34L15.56 15.45C15.8802 15.1282 16.3771 15.0625 16.77 15.29L20.63 17.54C20.8312 17.6575 20.9664 17.8619 20.9957 18.0931C21.0251 18.3242 20.9454 18.5559 20.78 18.72L19.09 20.41C18.7142 20.7881 18.203 21.0004 17.67 21H17Z"
  })));
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCall, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/call.dd08e096.svg";
export { ForwardRef as ReactComponent };